import { render } from "./ResetPasswordView.vue?vue&type=template&id=68a4360a"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ResetPasswordView.vue?vue&type=style&index=0&id=68a4360a&lang=scss&module=true"
cssModules["$style"] = style0
import "./ResetPasswordView.vue?vue&type=style&index=1&id=68a4360a&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__